import {inject, Injectable} from '@angular/core';
import {AbstractControl, AsyncValidator, ValidationErrors} from '@angular/forms';
import {catchError, map, Observable, of} from 'rxjs';
import {KeycloakUserService} from "../service/keycloak-user.service";

@Injectable({providedIn: 'root'})
export class UniqueKeycloakUsernameValidator implements AsyncValidator {

  keycloakUserService = inject(KeycloakUserService);

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    return this.keycloakUserService.isUserNameTaken(control.value).pipe(
      map((isTaken) => (isTaken ? {uniqueUsername: true} : null)),
      catchError(() => of(null)),
    );
  }

}
